"use strict";

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

function Flip(e, t) {
  function n(e) {
    function t() {
      var t = void 0;

      if (s || u || r || p || i || a) {
        var n = e && l,
            o = s || i || a ? (a ? n ? "" : "-" : n ? "-" : "") + "1" : "0",
            f = u || p || r ? (r ? n ? "" : "-" : n ? "-" : "") + "1" : "0";
        t = e ? "from {\n              transform: perspective(400px);\n            }\n\n            30% {\n              transform: perspective(400px) rotate3d(" + o + ", " + f + ", 0, -15deg);\n              opacity: 1;\n            }\n\n            to {\n              transform: perspective(400px) rotate3d(" + o + ", " + f + ", 0, 90deg);\n              opacity: 0;\n            }" : "from {\n              transform: perspective(400px) rotate3d(" + o + ", " + f + ", 0, 90deg);\n              animation-timing-function: ease-in;\n              opacity: 0;\n            }\n\n            40% {\n              transform: perspective(400px) rotate3d(" + o + ", " + f + ", 0, -20deg);\n              animation-timing-function: ease-in;\n            }\n\n            60% {\n              transform: perspective(400px) rotate3d(" + o + ", " + f + ", 0, 10deg);\n              opacity: 1;\n            }\n\n            80% {\n              transform: perspective(400px) rotate3d(" + o + ", " + f + ", 0, -5deg);\n            }\n\n            to {\n              transform: perspective(400px);\n            }";
      } else t = "from {\n              transform: perspective(400px) rotate3d(0, 1, 0, -360deg);\n              animation-timing-function: ease-out;\n              opacity: " + (e ? "1" : "0") + ";\n            }\n\n            40% {\n              transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);\n              animation-timing-function: ease-out;\n            }\n\n            50% {\n              transform: perspective(400px) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);\n              animation-timing-function: ease-in;\n            }\n\n            to {\n              transform: perspective(400px);\n              animation-timing-function: ease-in;\n              opacity: " + (e ? "0" : "1") + ";\n            }";

      return (0, _globals.animation)(t);
    }

    return {
      style: {
        backfaceVisibility: "visible"
      },
      make: t
    };
  }

  var o = e.out,
      r = e.left,
      p = e.right,
      i = e.top,
      a = e.bottom,
      s = e.x,
      u = e.y,
      l = e.opposite,
      f = (0, _objectWithoutProperties3.default)(e, ["out", "left", "right", "top", "bottom", "x", "y", "opposite"]);
  return t ? _react2.default.createElement(_Reveal2.default, (0, _extends3.default)({}, f, {
    in: n(!1),
    out: n(!0)
  })) : n(o);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _extends2 = require("babel-runtime/helpers/extends"),
    _extends3 = _interopRequireDefault(_extends2),
    _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties"),
    _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2),
    _react = require("react"),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require("prop-types"),
    _Reveal = require("./Reveal"),
    _Reveal2 = _interopRequireDefault(_Reveal),
    _globals = require("./globals"),
    propTypes = {
  out: _propTypes.bool,
  left: _propTypes.bool,
  right: _propTypes.bool,
  top: _propTypes.bool,
  bottom: _propTypes.bool,
  opposite: _propTypes.bool
},
    defaultProps = {};

Flip.propTypes = propTypes, Flip.defaultProps = defaultProps, exports.default = Flip, module.exports = exports.default;